<template>
  <div
    class="
      min-h-[160px] py-5
      w-full
      mt-[100px]
      layout-padding
      flex flex-wrap
      items-center
      justify-between
    "
    :class="bgColor"
  >
    <div class="my-4 ltr:mr-12 rtl:ml-12"><div class="font-bold text-2xl lg:text-4xl py-2">{{ title }}</div>
    <div class="text-sm capitalize mt-2 py-2">{{ parentTitle }} / {{ title }}</div></div>
    <slot></slot> 
  </div>
</template>
<script>
export default {
  props: ["title", "parentTitle", "bgColor"],
};
</script>